// Reusable tooltip wrapper

import { useState } from 'react';
import {
  autoUpdate,
  flip,
  FloatingPortal,
  safePolygon,
  useFloating,
  useFocus,
  useHover,
  useInteractions,
  useTransitionStyles,
} from '@floating-ui/react';

import './Tooltip.scss';

export const Tooltip = ({ children, tooltip, placement = 'bottom' }) => {
  // tooltip implementation
  // state on if the tooltip is open
  const [isOpen, setIsOpen] = useState(false);
  const { refs, context, floatingStyles } = useFloating({
    middleware: [flip()],
    placement: placement,
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
  });
  // transition on open
  const { isMounted, styles } = useTransitionStyles(context, {
    duration: {
      open: 750,
      close: 100,
    },
  });
  // safePolygon allows hover into the tooltip without it closing
  const hover = useHover(context, {
    delay: {
      close: 0,
      open: 300,
    },
    handleClose: safePolygon({
      requireIntent: false,
    }),
  });
  const focus = useFocus(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    focus,
  ]);

  return (
    <>
      <span ref={refs.setReference} {...getReferenceProps()}>
        {children}
        {isMounted && (
          <FloatingPortal>
            <span
              ref={refs.setFloating}
              style={{
                zIndex: 10000,
                ...floatingStyles,
              }}
              {...getFloatingProps()}
            >
              <span className="sb-tooltip" style={styles}>
                {tooltip}
              </span>
            </span>
          </FloatingPortal>
        )}
      </span>
    </>
  );
};
